module.exports = __webpack_public_path__ + "ui-static/img/hooks-filter-default_dark.f661faf5.svg";